
import { IOhInvestigation } from "../models/onHandDelivery";
import {
  CHECK_BOX_MSG,
  ConditionalField,
  CreateDynamicSchema,
  FieldConfig,
  OPTION_MSG,
  REQUIRED_MSG,
  RequiredField,
} from "./formik";

// Configuration array defining validation rules
const config: FieldConfig[] = [
  RequiredField("hasEmailEntryError", OPTION_MSG),
  RequiredField("wereAllPartiesContactedWithOhn", OPTION_MSG),
  RequiredField("wasCommunicationSuccessful", OPTION_MSG),
  RequiredField("isF18NotesAccurate", OPTION_MSG),
  RequiredField("wasOhnSentByCreditDept", OPTION_MSG),

  ConditionalField("billDetailsDescription", "wasOhnSentByCreditDept", "N"),
  ConditionalField("onHandDetails", "wasOhnSentByCreditDept", "N" ),
  ConditionalField(
    "didTerminalClearException",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG,
  ),
  ConditionalField("adeCallReason", "wasOhnSentByCreditDept", "N"),
  ConditionalField("isF9NotFlashingInAde",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField("hasBolInstructions",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "followedBolInstructions",
    "hasBolInstructions",
    "Y",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "doF18NotesMatchActions",
    "hasBolInstructions",
    "Y",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "hasImageCommunication",
    "hasBolInstructions",
    "Y",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "wasEveryDeliveryAttemptMade",
    "wasOhnSentByCreditDept",
    "N",
    true,
    CHECK_BOX_MSG,
    "string",
    true
  ),
  RequiredField("deliveryAttemptSteps", "", false),
  ConditionalField(
    "wasShipperContactedWithin24hrs",
    "wasOhnSentByCreditDept",
    "N",
    true,
    CHECK_BOX_MSG,
    "string",
    true
  ),
  RequiredField("shipperContactSteps", "", false),
  ConditionalField(
    "isFreightOnHandDueToDamage",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),

  ConditionalField("shipmentCallFor", "isFreightOnHandDueToDamage"),
  ConditionalField("productDescription", "isFreightOnHandDueToDamage"),
  ConditionalField("packageDamageDescription", "isFreightOnHandDueToDamage"),
  ConditionalField("actualProductDamageDetails", "isFreightOnHandDueToDamage"),
  ConditionalField(
    "actualProductNotDamagedDetails",
    "isFreightOnHandDueToDamage"
  ),
  ConditionalField(
    "canProductBeRecoupedForRedelivery",
    "isFreightOnHandDueToDamage"
  ),
  ConditionalField("isProductRepairable", "isFreightOnHandDueToDamage"),
  ConditionalField("hasValidDamagePictures", "isFreightOnHandDueToDamage"),
  ConditionalField("isProductGlass", "isFreightOnHandDueToDamage"),

  ConditionalField(
    "ohnVerbiageCorrect",
    "wasOhnSentByCreditDept",
    "N",
    true,
    CHECK_BOX_MSG,
    "string",
    true
  ),
  ConditionalField(
    "wasContactFrom7823",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField("stepsTakenFrom7823", "wasContactFrom7823"),
  ConditionalField(
    "wasContactFrom8511",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField("stepsTakenFrom8511", "wasContactFrom8511"),
  ConditionalField(
    "googleCheck",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField("googleCheckResponse", "googleCheck"),
  ConditionalField(
    "pickupScreenCheck",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField("pickupScreenResponse", "pickupScreenCheck"),
  ConditionalField(
    "salesRepCheck",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField("salesRepResponse", "salesRepCheck"),

  ConditionalField(
    "isShipperValueInWriting",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "communicationImagedByTerminal",
    "wasOhnSentByCreditDept",
    "N",
    true,
    CHECK_BOX_MSG,
    "string",
    true
  ),
  ConditionalField(
    "f18NotesUpdatedByAll",
    "wasOhnSentByCreditDept",
    "N",
    true,
    CHECK_BOX_MSG,
    "string",
    true
  ),
  ConditionalField(
    "freightHasAppointment",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  ConditionalField(
    "storageChargesApproved",
    "wasOhnSentByCreditDept",
    "N",
    true,
    OPTION_MSG
  ),
  RequiredField("f18Note", REQUIRED_MSG, true, "string", false, 150, "Maximum 150 characters allowed"),
];
// Function to create a Yup validation schema dynamically from the config array

// Exporting the dynamically created schema
export const onHandInvestigationSchema = CreateDynamicSchema(config);

export const intiOnHandInvestigationFormValue: IOhInvestigation = {
  hasEmailEntryError: undefined,
  wereAllPartiesContactedWithOhn: undefined,
  wasCommunicationSuccessful: undefined,
  isF18NotesAccurate: undefined,
  wasOhnSentByCreditDept: undefined,
  billDetailsDescription: undefined,
  onHandDetails: undefined,
  didTerminalClearException: undefined,
  adeCallReason: undefined,
  isF9NotFlashingInAde: undefined,
  hasBolInstructions: undefined,
  followedBolInstructions: undefined,
  doF18NotesMatchActions: undefined,
  hasImageCommunication: undefined,
  wasEveryDeliveryAttemptMade: undefined,
  deliveryAttemptSteps: undefined,
  wasShipperContactedWithin24hrs: undefined,
  shipperContactSteps: undefined,
  isFreightOnHandDueToDamage: undefined,
  shipmentCallFor: undefined,
  productDescription: undefined,
  packageDamageDescription: undefined,
  actualProductDamageDetails: undefined,
  actualProductNotDamagedDetails: undefined,
  canProductBeRecoupedForRedelivery: undefined,
  isProductRepairable: undefined,
  hasValidDamagePictures: undefined,
  isProductGlass: undefined,
  ohnVerbiageCorrect: undefined,
  wasContactFrom7823: undefined,
  stepsTakenFrom7823: undefined,
  wasContactFrom8511: undefined,
  stepsTakenFrom8511: undefined,
  googleCheck: undefined,
  googleCheckResponse: undefined,
  pickupScreenCheck: undefined,
  pickupScreenResponse: undefined,
  salesRepCheck: undefined,
  salesRepResponse: undefined,
  isShipperValueInWriting: undefined,
  communicationImagedByTerminal: undefined,
  f18NotesUpdatedByAll: undefined,
  freightHasAppointment: undefined,
  storageChargesApproved: undefined,
  f18Note: undefined,
};
